import type { InsurerPolicyRow } from '@/services/commissionReports';

export interface MoneyColumn {
  key: keyof InsurerPolicyRow;
  label: string;
}

/** The broker's commercial terms. A POSP must never see any of these. */
const BROKER_COLUMNS: MoneyColumn[] = [
  { key: 'total_commission', label: 'Received' },
  { key: 'posp_commission', label: 'To POSP' },
  { key: 'platform_commission', label: 'Platform' },
  { key: 'broker_commission', label: 'Broker' },
  { key: 'margin', label: 'Margin' },
];

const POSP_COLUMNS: MoneyColumn[] = [{ key: 'your_commission', label: 'Your Commission' }];

/**
 * The money columns the drill-down payload ACTUALLY carries.
 *
 * The rows are role-shaped (apps/commissions/visibility.py): a broker gets
 * total/posp/platform/broker/margin, a POSP gets only `your_commission` and the
 * broker-side keys are ABSENT — deliberately absent, not zeroed, because any of
 * them lets an agent derive exactly what margin the broker keeps on every policy
 * they write.
 *
 * So the columns are DERIVED from the payload, never assumed. Hard-coding the
 * broker set would hand a POSP five columns whose headers alone ("Margin",
 * "Received") describe the broker's terms — reopening in the UI the leak the API
 * just closed.
 */
export function insurerPolicyMoneyColumns(rows: InsurerPolicyRow[]): MoneyColumn[] {
  const present = (col: MoneyColumn) => rows.some((row) => row[col.key] !== undefined);
  return [...BROKER_COLUMNS.filter(present), ...POSP_COLUMNS.filter(present)];
}
